import { observer } from "mobx-react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import localesListStore from "../../stores/locales-list-store";
import "./upload-translations-container.scss";
import FileUpload, { FILE_UPLOAD_VARIANTS } from "../../../../components/file-upload/file-upload";


const UploadTranslationsContainer: React.FC = observer(() => {

    return (
        <div className="upload-translations-container">
            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{"Upload translations file"}</FontBody1>
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                    {"Upload your file with completed translations. Required format: CSV"}
                </FontBody2>
            </div>
            <div className="upload-translations-container-cta">
                <FileUpload
                    uploadFile={localesListStore.uploadTranslationsFile}
                    buttonText={"UPLOAD FILE"}
                    variant={FILE_UPLOAD_VARIANTS.Secondary}
                    readType="text"
                    fileTypes={["text/csv"]}
                    isLoading={localesListStore.isUploading()}
                    disabled={localesListStore.isDownloading() || localesListStore.isUploading()}
                />
                { localesListStore.uploadedSuccessfuly() &&
                    <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]} >File Uploaded Successfully!</FontBody2>
                }
                {/** Not ready, uncomment when https://returngo.atlassian.net/browse/ET-956 is merged  */}
                {/*
                <FontBody2 color={FONT_COLOR.ACCENT1}>
                    {"Last Updated: "}<FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT1}>{localesListStore.lastUpdateTimestamp}</FontBody2>
                </FontBody2>
                */}
            </div>
        </div>
    );
});

export default UploadTranslationsContainer;